const blue = {
  100: '#46b9f3'
};

export { blue };
